export default __webpack_public_path__ + "static/media/rightThump.11960717.svg";